import React from "react";
import { Link } from "react-router-dom";
import theme from "../theme";

const Footer = () => {
  const styles = {
    footer: {
      backgroundColor: theme.colors.secondaryDark,
      color: theme.colors.white,
      padding: `${theme.spacing.xl} ${theme.spacing.md}`,
      marginTop: theme.spacing["3xl"],
      borderTop: `1px solid ${theme.colors.border}`,
    },
    container: {
      maxWidth: "1280px",
      margin: "0 auto",
    },
    content: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
      gap: theme.spacing.xl,
      marginBottom: theme.spacing.lg,
    },
    section: {
      display: "flex",
      flexDirection: "column",
    },
    heading: {
      fontSize: theme.typography.fontSize.lg,
      fontWeight: theme.typography.fontWeight.bold,
      marginBottom: theme.spacing.sm,
      fontFamily: theme.typography.fontFamily.heading,
    },
    text: {
      fontSize: theme.typography.fontSize.base,
      color: theme.colors.textLight,
      lineHeight: theme.typography.lineHeight.relaxed,
      fontFamily: theme.typography.fontFamily.primary,
    },
    links: {
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing.xs,
    },
    link: {
      color: theme.colors.textLight,
      textDecoration: "none",
      fontSize: theme.typography.fontSize.base,
      transition: theme.transitions.fast,
      fontFamily: theme.typography.fontFamily.primary,
    },
    downloadButtons: {
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing.sm,
    },
    downloadButton: {
      padding: `${theme.spacing.md} ${theme.spacing.lg}`,
      fontSize: theme.typography.fontSize.lg,
      fontWeight: theme.typography.fontWeight.semibold,
      borderRadius: theme.borderRadius.md,
      textDecoration: "none",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      transition: theme.transitions.base,
      fontFamily: theme.typography.fontFamily.primary,
      border: "none",
      cursor: "pointer",
      width: "auto",
      minWidth: "unset",
      boxSizing: "border-box",
      backgroundColor: theme.colors.primary,
      color: theme.colors.white,
    },
    downloadButtonHover: {
      backgroundColor: theme.colors.primaryDark,
    },
    divider: {
      height: "1px",
      backgroundColor: theme.colors.textSecondary,
      margin: `${theme.spacing.lg} 0`,
    },
    bottom: {
      textAlign: "center",
      color: theme.colors.textLight,
      fontSize: theme.typography.fontSize.sm,
      fontFamily: theme.typography.fontFamily.primary,
    },
  };

  return (
    <footer style={styles.footer}>
      <div style={styles.container}>
        <div style={styles.content}>
          {/* Company Info */}
          <div style={styles.section}>
            <div style={{ flexDirection: "row",alignItems: "center", display: "flex", gap: theme.spacing.xs, height: "auto" }}>
              <img
                src={require("../assets/images/logo.png")}
                alt="WODGoat"
                style={{ width: "100px", height: "auto" }}
              />
              <h3>WODGoat</h3>
            </div>
            <p style={styles.text}>
              Log workouts hands-free with WODGoat AI — Voice-powered tracking,
              automatic exercise structuring, workout timer, personal records,
              and shareable achievements.{" "}
            </p>
          </div>

          {/* Quick Links */}
          <div style={styles.section}>
            <h3 style={styles.heading}>Quick Links</h3>
            <div style={styles.links}>
              <Link
                to="/"
                style={styles.link}
                onMouseOver={(e) => (e.target.style.color = theme.colors.white)}
                onMouseOut={(e) =>
                  (e.target.style.color = theme.colors.textLight)
                }
              >
                Home
              </Link>
              <Link
                to="/privacy"
                style={styles.link}
                onMouseOver={(e) => (e.target.style.color = theme.colors.white)}
                onMouseOut={(e) =>
                  (e.target.style.color = theme.colors.textLight)
                }
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms"
                style={styles.link}
                onMouseOver={(e) => (e.target.style.color = theme.colors.white)}
                onMouseOut={(e) =>
                  (e.target.style.color = theme.colors.textLight)
                }
              >
                Terms & Conditions
              </Link>
              <Link
                to="/contact"
                style={styles.link}
                onMouseOver={(e) => (e.target.style.color = theme.colors.white)}
                onMouseOut={(e) =>
                  (e.target.style.color = theme.colors.textLight)
                }
              >
                Contact Us
              </Link>
            </div>
          </div>

          {/* Download App */}
          <div style={styles.section}>
            <h3 style={styles.heading}>Download App</h3>
            <div style={styles.downloadButtons}>
              <a
                href="https://apps.apple.com/us/app/wodgoat/id6761220753"
                target="_blank"
                rel="noopener noreferrer"
                style={styles.downloadButton}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = styles.downloadButtonHover.backgroundColor;
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = styles.downloadButton.backgroundColor;
                }}
              >
                📱 App Store
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.wodgoat&pcampaignid=web_share"
                target="_blank"
                rel="noopener noreferrer"
                style={styles.downloadButton}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = styles.downloadButtonHover.backgroundColor;
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = styles.downloadButton.backgroundColor;
                }}
              >
                🤖 Google Play
              </a>
            </div>
          </div>
        </div>

        <div style={styles.divider}></div>

        <div style={styles.bottom}>
          <p>© 2026 WODGoat. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
